<template>
  <slot v-if="shouldDisplay"></slot>
</template>

<script>
export default {
  name: "IsContributor",
  data() {
    return {
      roles: [
          'Contributor',
          'Admin',
          'Manager'
      ]
    }
  },
  methods: {
    shouldDisplay() {
      return this.roles.includes(this.userRole)
    }
  },
  computed: {
    userRole() {
      return this.$store.getters.getGravyUserRole
    }
  }
}
</script>

<style scoped>

</style>